export default __webpack_public_path__ + "static/media/eolic-energy.c11bb24f.png";